import type { ICTShapeProperties } from '@tencent/slide-sdk-model';
import { STShapeType } from '@tencent/slide-sdk-model';
import { SpreadJS } from './spreadjs-lib';
import { GraphicsType } from './spreadjs-lib/graphic-type';

interface Rect {
    left: number;
    top: number;
    width: number;
    height: number;
}

/**
 * 计算控制点
 * https://git.woa.com/SNG-RDCenter-Beijing/Docs-PPT/blob/cab77130fa6af253c7bdb0635bd5466bad1aae72/src/slide/domain/ui-model/converter/node-property/module-property/graphic-info/graphic-info-converter.ts#L125
 */
const calcControlValues = (avList: any[]): Array<number> => {
    const controlValues: Array<number> = [];
    for (let i = 0, len = avList.length; i < len; i++) {
        const fmla = avList[i]?.fmla;
        if (!fmla) continue;
        const afterSplit = fmla?.split(' ');
        if (afterSplit.length > 1) {
            controlValues.push(Number(afterSplit[1]) / 100000);
        }
    }
    return controlValues;
}

// 以下这些类型不会用 SpreadJSShape, 不需要额外计算 rect
// https://git.woa.com/SNG-RDCenter-Beijing/tencent-docs-drawing/blob/b1258578d09989223d9059bcbc84674bba9d4f59/packages/alloy-graphics/src/path/graphics-parser.ts#L16
const NOT_SPREAD_SHAPE_LIST = [
    GraphicsType.CUSTOM,
    GraphicsType.RECT,
    GraphicsType.LINE,
    GraphicsType.STRAIGHT_CONNECTOR,
    GraphicsType.BENT_CONNECTOR_0,
    GraphicsType.BENT_CONNECTOR_1,
    GraphicsType.BENT_CONNECTOR_2,
    GraphicsType.BENT_CONNECTOR_3,
    GraphicsType.CURVED_CONNECTOR_0,
    GraphicsType.CURVED_CONNECTOR_1,
    GraphicsType.CURVED_CONNECTOR_2,
    GraphicsType.CURVED_CONNECTOR_3
] as string[];

/**
 * 计算形状实际的文本区域
 * https://git.woa.com/SNG-RDCenter-Beijing/tencent-docs-drawing/blob/4badc8fb5ea936618726ad63ea39608651a2af44/packages/alloy-graphics/src/path/shape/spreadJS-shape.ts#L55
 */
export const calcTextRect = (spPr: ICTShapeProperties): Rect => {
    const width = spPr.xfrm?.ext?.cx ?? 0;
    const height = spPr.xfrm?.ext?.cy ?? 0;

    const defaultResult = {
        left: 0,
        top: 0,
        width,
        height,
    };

    if (spPr.prstGeom?.prst === undefined) return defaultResult;

    const shapeType = STShapeType[spPr.prstGeom.prst];
    if (NOT_SPREAD_SHAPE_LIST.includes(shapeType)) return defaultResult;

    const controlValues = spPr.prstGeom.avLst?.gd
        ? calcControlValues(spPr.prstGeom.avLst.gd)
        : undefined;

    const spreadJS = new SpreadJS();
    spreadJS.getPropertySource(spreadJS.getBaseShape(shapeType), width, height);
    const { textRect } = spreadJS.getTextRect(shapeType, controlValues, width, height);
    if (textRect === undefined) return defaultResult;

    return {
        left: textRect.left,
        top: textRect.top,
        width: textRect.right - textRect.left,
        height: textRect.bottom - textRect.top,
    };
};